// extracted by mini-css-extract-plugin
export var standaloneTable = "_k1-0";
export var standaloneTableWithBodyFill = "_k1-1";
export var withExtraHeader = "_k1-2";